export enum IbCreditFunctionName {}

export enum IbCreditInputName {
  GST_IN = 'gstin',
  CONTACT_PERSON_NAME = 'name',
  MOBILE_NO = 'phone_number',
  EMAIL_ID = 'email_id',
  FINANCE_PERSON_NAME = 'finance_person_name',
  FINANCE_DESIGNATION = 'finance_designation',
  FINANCE_EMAIL = 'finance_email',
  FINANCE_PHONE = 'finance_phone',
  OTP = 'otp',
  MOBILE_NO_VERIFIED = 'mobileNoVerified',
  GST_IN_VERIFIED = 'gstInVerified',
}

export class IbCreditFormDto {
  contactPersonName: string;
  emailId: string;
  mobileNo: string;
  gstin: string;
  finaneDesignation: string;
  financeEmail: string;
  financePersonName: string;
  financePhone: string;
  gstInVerified: boolean;

  constructor(partial: Partial<IbCreditFormDto>) {
    Object.assign(this, partial);
  }
}
